export default __webpack_public_path__ + "static/media/iconotres.8ef80950.svg";